<template>
	<v-btn color='red' :text="!solid" @click="confirmFileDelete" :style="{ color: 'white' }" ><v-icon left v-if="resting">mdi-delete</v-icon>
		Delete		
	</v-btn>
</template>

<script>
export default {
	name: 'DeleteButton',
	props: {
		solid: {
			type: Boolean,
			default: false,			
		},
		folderTitle: String
	},
	data() {
		return {
			resting: true,
		}
	},
	methods: {
		async confirmFileDelete(file) {
			console.log(this.title)
			this.$swal({
				title: 'Are you sure that you want to delete folder ' +  this.folderTitle + ' ?',
				icon: 'warning',
				confirmButtonColor: '#11d472',
				cancelButtonColor: '#FF0000',
				showCancelButton: true,
				cancelButtonText: 'No',
				confirmButtonText: 'Yes'
				}).then((result) =>  {
					if(result.isConfirmed){
						this.$emit('doDelete')
					}							
			})
		},
	},
}
</script>